(() => {
  function nicheShape(s) {
    const left = Number(s.skewLeft || 0), right = Number(s.skewRight || 0);
    return {left, right, woodLength: s.length + Math.max(0,left) + Math.max(0,right), rearLength:s.length + left + right, visibleRails:left>0 || right>0};
  }
  // Interne fabriekstabel van Jeroen voor nisplanken.
  // Voor vrijdragende wandplanken gelden andere draagkrachtregels.
  function deepFloatingEligible(s) {
    return Number.isInteger(s.length) && s.length > 0 && s.length <= 800 &&
      s.thickness === 40 && Boolean(s.wallLeft) !== Boolean(s.wallRight);
  }
  function floatingDepthMax(c, s) {
    return c.isFloating && deepFloatingEligible(s) ? 500 : Number(c.depthMax || 350);
  }
  function nicheRearSupport(s, isFloating = false) {
    const depth = Number(s.depth), thickness = Number(s.thickness);
    if (![26, 30, 35, 40].includes(thickness))
      throw Error("Kies een standaarddikte: 26, 30, 35 of 40 mm.");
    if (!Number.isFinite(depth) || depth < 1)
      throw Error("Vul een geldige plankdiepte in.");
    if (depth <= 170)
      return { key: "titan", name: "Titan 3D", reinforced: false };
    if (depth <= 240) {
      if (thickness === 26)
        return { key: "triade-mini", name: "Triade Mini", reinforced: false };
      if (thickness === 30 || thickness === 35)
        return { key: "triade", name: "Triade Pro", reinforced: false };
      return { key: "triade-maxi", name: "Triade Maxi", reinforced: false };
    }
    if (depth <= 310 && thickness === 40)
      return { key: "triade-maxi", name: "Triade Maxi", reinforced: true };
    if ((depth <= 400 || (isFloating && depth <= 500 && deepFloatingEligible(s))) && thickness === 40)
      return { key: "triade-xxl", name: "Triade XXL", reinforced: true };
    if (depth > 400)
      throw Error((isFloating ? "Een zwevende wandplank" : "Een nisplank") + " dieper dan 400 mm is nog niet via deze configurator bestelbaar.");
    throw Error("Bij een " + (isFloating ? "zwevende wandplank" : "nisplank") + " dieper dan 240 mm is alleen een dikte van 40 mm mogelijk.");
  }
  // Basis-aantalsstaffel voor zwevende wandplanken vóór eventuele zijdragers.
  // Een nis-/zijdrager vervangt de dichtstbijzijnde achterdrager.
  function floatingRearSupportCount(length) {
    if (!Number.isInteger(length) || length < 250 || length > 3800)
      throw Error("Kies een wandplanklengte tussen 250 en 3800 mm.");
    if (length <= 1000) return 2;
    if (length <= 1624) return 3;
    if (length <= 2375) return 4;
    if (length <= 3124) return 5;
    return 6;
  }
  function nicheBrackets(c, s) {
    if (c.isCabinetTop) return {
      sideCount: 0, baseRearCount: 0, rearCount: 0, rearPositions: [],
      rearPrice: 0, rearSupportType: "", rearSupportName: "", rearSupportGrossCents: 0,
      rearBracketCount: 0, woodenRailCount: 0, woodenRailExtra: 0,
      rearSupportCost: 0, sideSupportCost: 0, brackets: 0,
    };
    const tiers = [1, 2, 3, 4].map((i) => ({
      from: c["rearFrom" + i],
      count: c["rearCount" + i],
    }));
    const valid =
      Number.isInteger(c.sideCount) &&
      c.sideCount >= 0 &&
      Number.isFinite(c.sidePrice) &&
      c.sidePrice >= 0 &&
      tiers.every(
        (t, i) =>
          Number.isInteger(t.from) &&
          t.from > 0 &&
          Number.isInteger(t.count) &&
          t.count >= 0 &&
          (!i || (t.from > tiers[i - 1].from && t.count >= tiers[i - 1].count)),
      );
    if (!valid)
      throw Error(c.nicheText?.invalid || "Ongeldige dragerinstellingen.");

    const selected = nicheRearSupport(s, c.isFloating);
    let rearCount = 0;
    for (const tier of tiers) if (s.length >= tier.from) rearCount = tier.count;
    const woodenRails = !c.isFloating && nicheShape(s).visibleRails;
    // Nisplanken houden hun eigen instelbare staffel. Bij zwevende wandplanken
    // vervangen optionele nisdragers de buitenste achterdragers per zijde.
    // We behouden voor de overige dragers exact hun oorspronkelijke posities.
    const baseRearCount = c.isFloating ? floatingRearSupportCount(s.length) : rearCount;
    const minimumGap = c.isFloating ? (s.length < 450 ? Math.max(1,s.length-200) : 250) : 100;
    const margin = Math.max(100,Math.min(250,Math.floor((s.length-(baseRearCount-1)*minimumGap)/2)));
    const baseRearPositions = c.isFloating
      ? Array.from({ length: baseRearCount }, (_, i) =>
          Math.round(margin + i * (s.length - 2*margin) / (baseRearCount - 1)))
      : Array.from({ length: baseRearCount }, (_, i) =>
          Math.round(((i + 1) * s.length) / (baseRearCount + 1)));
    const removeLeft = c.isFloating && Boolean(s.wallLeft) ? 1 : 0;
    const removeRight = c.isFloating && Boolean(s.wallRight) ? 1 : 0;
    let rearPositions = woodenRails ? [] :
      baseRearPositions.slice(removeLeft, baseRearCount - removeRight);
    if (c.kind === "niche" && rearPositions.length) {
      const pocket = electricalLayout(c, s)?.pocket || {x:-10000,w:0};
      if (pocket) {
        // Vanaf de plankuiteinden minimaal 100 mm tot het dragerhart.
        // Vanaf de buitenranden van de trafouitfrezing minimaal 80 mm.
        const allowed = [];
        for (let x = 100; x <= s.length - 100; x++) {
          if (x <= pocket.x - 80 || x >= pocket.x + pocket.w + 80) allowed.push(x);
        }
        // Zoek de kleinste totale verplaatsing, in dezelfde volgorde.
        // Houd ook minimaal 100 mm tussen de dragerharten.
        const originals = rearPositions;
        const candidates = allowed.filter((x, i) => i === 0 || x !== allowed[i - 1]);
        let states = [{positions:[], cost:0}];
        for (const [supportIndex, original] of originals.entries()) {
          const next = [];
          let index = 0, bestPrevious = null;
          for (const x of candidates) {
            if (c.isFloating && s.lighting === "yes" && s.transformerLocation !== "external" &&
                ((!s.wallLeft && supportIndex === 0 && x !== 100) ||
                 (!s.wallRight && supportIndex === originals.length - 1 && x !== s.length - 100))) continue;
            while (index < states.length &&
              (!states[index].positions.length ||
                states[index].positions[states[index].positions.length - 1] <= x - minimumGap)) {
              if (!bestPrevious || states[index].cost < bestPrevious.cost)
                bestPrevious = states[index];
              index++;
            }
            if (bestPrevious) next.push({
              positions:[...bestPrevious.positions,x],
              cost:bestPrevious.cost + Math.abs(x - original)
            });
          }
          states = next;
        }
        if (!states.length)
          throw Error("Er is onvoldoende ruimte tussen de dragers en de trafouitfrezing. Verplaats de trafo of kies een externe trafo.");
        states.sort((a,b) => a.cost-b.cost);
        rearPositions = states[0].positions;
      }
    }
    if (c.isFloating && Array.isArray(s.customRearPositions)) {
      const manual = s.customRearPositions;
      if (manual.length < rearPositions.length || manual.length > 16 ||
          manual.some(x => !Number.isInteger(x)))
        throw Error("Vul geldige dragerposities in hele millimeters in.");
      rearPositions = manual.slice();
    }
    if (c.isFloating && Array.isArray(s.customRearPositions) && rearPositions.length) {
      const fail = message => {
        throw Error(s.lighting === "yes" && s.transformerLocation !== "external" &&
          rearPositions.length > baseRearCount - removeLeft - removeRight
          ? "Verwijder een extra drager om verlichting toe te voegen." : message);
      };
      for (let i = 0; i < rearPositions.length; i++) {
        const x = rearPositions[i];
        if (!Number.isInteger(x) || x < 100 || x > s.length - 100)
          fail("Het hart van iedere drager moet minimaal 100 mm van de plankuiteinden liggen.");
        if (i && (x - rearPositions[i - 1] < (s.length < 450 && rearPositions.length <= baseRearCount-removeLeft-removeRight ? minimumGap : 250) || x - rearPositions[i - 1] > 700))
          fail("De onderlinge afstand tussen dragers moet 250 tot 700 mm zijn.");
      }
      const cutout = s.lighting === "yes" && s.transformerLocation !== "external"
        ? electricalLayout(c, s)?.pocket : null;
      if (cutout && rearPositions.some(x => x > cutout.x - 80 && x < cutout.x + cutout.w + 80))
        fail("Houd het hart van elke drager minimaal 80 mm buiten de trafouitfrezing.");
      if (cutout && ((!s.wallLeft && rearPositions[0] !== 100) ||
          (!s.wallRight && rearPositions[rearPositions.length - 1] !== s.length - 100)))
        fail("Zet de buitenste drager op 100 mm vanaf het vrije plankuiteinde.");
    }
    const effectiveRearCount = rearPositions.length;
    const sideCount = c.isFloating
      ? removeLeft + removeRight
      : c.sideCount;
    const data = c.rearSupportCatalog?.[selected.key] || {};
    // Webshopvariantprijzen zijn inclusief btw en worden hier omgerekend
    // naar bedragen exclusief btw, omdat de overige productiekosten netto zijn.
    const unitGrossCents = Number(data.priceCents);
    const bracketGrossCents = selected.reinforced ? Number(data.bracketCents) : 0;
    if (effectiveRearCount > 0 &&
      (!Number.isInteger(unitGrossCents) || unitGrossCents <= 0 ||
       (selected.reinforced && (!Number.isInteger(bracketGrossCents) || bracketGrossCents <= 0))))
      throw Error("De webshopprijs van " + selected.name + (selected.reinforced ? " of de bracketset" : "") + " ontbreekt. Controleer de dragerkoppeling.");
    const grossCentsPerRear = (effectiveRearCount > 0 ? unitGrossCents + bracketGrossCents : 0);
    const rearPrice = grossCentsPerRear / 100 / (1 + c.vat / 100);
    const rearSupportCost = effectiveRearCount * rearPrice;
    const configuredRailExtra = Number(c.woodRailExtraPerSide);
    const railExtraPerSide =
      Number.isFinite(configuredRailExtra) && configuredRailExtra >= 0
        ? configuredRailExtra
        : 0;
    const woodenRailCount = woodenRails ? 2 : 0;
    const woodenRailExtra = woodenRailCount * railExtraPerSide;
    const sideSupportCost = sideCount * c.sidePrice;
    return {
      sideCount,
      baseRearCount,
      rearCount: effectiveRearCount,
      rearPositions,
      rearPrice,
      rearSupportType: effectiveRearCount ? selected.key : "",
      rearSupportName: effectiveRearCount ? selected.name : "",
      rearSupportGrossCents: effectiveRearCount * grossCentsPerRear,
      rearBracketCount: effectiveRearCount && selected.reinforced ? effectiveRearCount : 0,
      woodenRailCount,
      woodenRailExtra,
      rearSupportCost,
      sideSupportCost,
      brackets: sideSupportCost + rearSupportCost + woodenRailExtra,
    };
  }
  function electricalLayout(c, s) {
    if (s.lighting !== "yes") return null;
    if (s.transformerLocation === "external")
      return {
        location: "external",
        groove: s.lightingType === "own-strip" && s.strip?.mode === "full"
          ? null
          : { direction: s.cableDirection, width: 10, depth: 10 },
      };
    const inset = 20 + c.lightingGeometry.clearance;
    const point =
      s.lightingType === "own-strip"
        ? s.strip.feed === "left"
          ? s.strip.left
          : s.length - s.strip.right
        : s.electricalPoint;
    const leftInset = c.isFloating && !s.wallLeft ? Math.max(inset, 180) : inset;
    const rightInset = c.isFloating && !s.wallRight ? Math.max(inset, 180) : inset;
    const centre = Math.max(
      leftInset + 175,
      Math.min(point, s.length - rightInset - 175),
    );
    return {
      location: "internal",
      electricalPoint: point,
      pocket: { x: centre - 175, y: 0, w: 350, h: 65, height: 30, centre },
    };
  }
  function validateSpotGeometry(c, s) {
    const errors = [];
    if (c.kind !== "niche" || s.lighting !== "yes") return errors;
    if (s.thickness !== 40) errors.push({ key: "spot_thickness" });
    const layout = electricalLayout(c, s);
    if (layout.location === "internal") {
      if (
        s.lightingType !== "own-strip" &&
        (!Number.isInteger(s.electricalPoint) ||
          s.electricalPoint < 0 ||
          s.electricalPoint > s.length)
      )
        errors.push({ key: "electrical_invalid" });
      if (
        s.length < 350 + 2 * (20 + c.lightingGeometry.clearance) ||
        s.depth < 65 + c.lightingGeometry.clearance
      )
        errors.push({ key: "spot_pocket" });
    }
    if (s.lightingType === "own-strip")
      return errors.concat(validateStrip(c, s));
    if (!["own-spots", "our-spots"].includes(s.lightingType)) return errors;
    const a = s.spots,
      g = c.lightingGeometry,
      margin = g.clearance,
      r = a.diameter / 2;
    if (
      !Number.isInteger(a.count) ||
      a.count < 1 ||
      a.count > 50 ||
      !Number.isInteger(a.diameter) ||
      a.diameter <= 0 ||
      !Number.isInteger(a.routingDepth) ||
      a.routingDepth <= 0 ||
      a.routingDepth >= s.thickness ||
      a.positions.length !== a.count
    ) {
      errors.push({ key: "spot_required" });
      return errors;
    }
    const rearCentres = nicheBrackets(c, s).rearPositions;
    a.positions.forEach((p, i) => {
      const push = (key, extra = {}) =>
        errors.push({ key, index: i, ...extra });
      if (!Number.isInteger(p.x) || !Number.isInteger(p.y)) {
        push("spot_required");
        return;
      }
      if (p.x - r < 0 || p.x + r > s.length || p.y - r < 0 || p.y + r > s.depth)
        push("spot_boundary");
      if (s.edges === "beveled" && s.depth - p.y < g.bevelClearance + r)
        push("spot_front", { min: g.bevelClearance + r });
      if (p.x - r < 20 + margin || p.x + r > s.length - 20 - margin)
        push("spot_side");
      if (rearCentres.some((x) => Math.abs(p.x - x) <= r))
        push("spot_bracket");
      for (let j = 0; j < i; j++)
        if (
          Math.hypot(p.x - a.positions[j].x, p.y - a.positions[j].y) <
          a.diameter + margin
        ) {
          push("spot_overlap");
          errors.push({ key: "spot_overlap", index: j });
        }
    });
    return errors;
  }

  function validateStrip(c, s) {
    const a = s.strip,
      errors = [],
      fail = (key) => errors.push({ key });
    if (
      !a ||
      ![a.left, a.right, a.width, a.depth, a.centreline].every(
        Number.isInteger,
      ) ||
      a.left < 0 ||
      a.right < 0 ||
      a.width <= 0 ||
      a.depth <= 0 ||
      a.depth >= s.thickness ||
      a.left + a.right >= s.length
    ) {
      fail("strip_invalid");
      return errors;
    }
    const shape = nicheShape(s);
    const nearSide = Math.max(0, 1 - (a.centreline - a.width / 2) / s.depth);
    if (a.left < Math.max(0,-shape.left)*nearSide || a.right < Math.max(0,-shape.right)*nearSide)
      errors.push({key:"strip_shape"});
    if (a.centreline - a.width / 2 < 0 || a.centreline + a.width / 2 > s.depth)
      fail("strip_bounds");
    if (nicheBrackets(c, s).rearCount > 0 && a.centreline < 80)
      fail("strip_rear");
    if (s.edges === "beveled" && s.depth - a.centreline < 100)
      fail("strip_front");
    const pocket = electricalLayout(c, s)?.pocket,
      m = c.lightingGeometry.clearance;
    const start = a.left,
      end = s.length - a.right,
      near = a.centreline - a.width / 2,
      far = a.centreline + a.width / 2;
    if (pocket) {
      const dx = Math.max(pocket.x - end, start - (pocket.x + pocket.w), 0),
        dy = Math.max(pocket.y - far, near - (pocket.y + pocket.h), 0);
      if (Math.hypot(dx, dy) < m) fail("strip_transformer");
    }
    return errors;
  }

  function lightingPrice(c, s) {
    const supplied =
      c.kind === "niche" &&
      s.lighting === "yes" &&
      s.lightingType === "our-spots";
    const selectedControl = supplied
      ? c.lightingControls?.[s.lightingControl]
      : null;
    if (
      supplied &&
      (!selectedControl ||
        !Number.isInteger(selectedControl.cents) ||
        selectedControl.cents < 0)
    )
      throw Error("De productprijs van de bediening ontbreekt.");
    const controlCents = selectedControl?.cents || 0;
    const selectedSpot = selectedControl
      ? c.spotProducts?.[s.spotColour]
      : null;
    if (
      selectedControl &&
      (!selectedSpot ||
        !Number.isInteger(selectedSpot.cents) ||
        selectedSpot.cents < 0)
    )
      throw Error("De productprijs van het spotje ontbreekt.");
    const spotUnitCents = selectedSpot?.cents || 0;
    const spotCents = spotUnitCents * (selectedControl ? s.spots.count : 0);
    return { controlCents, spotUnitCents, spotCents };
  }

  function selectedWoodTier(c, s) {
    const requiredLength = c.kind === "niche" ? nicheShape(s).woodLength : s.length;
    // Bij elke ingekochte lengte houden we rekening met kopafkorting aan beide kanten.
    const configuredTrim = Number(c.trimEachEndMm);
    const trimEachEndMm = Number.isFinite(configuredTrim) && configuredTrim >= 0 ? configuredTrim : 100;
    const totalEndTrimMm = 2 * trimEachEndMm;
    const availableTiers = (Array.isArray(c.woodTiers) ? c.woodTiers : [])
      .map((tier) => ({ length: Number(tier.length), price: Number(tier.price),
        rawThickness: Number(tier.rawThickness ?? 52) }))
      .filter((tier) => Number.isInteger(tier.length) && tier.length > totalEndTrimMm && Number.isFinite(tier.price) && tier.price > 0)
      .sort((a, b) => a.length - b.length);
    const rawThicknessUsed = s.thickness <= 30 && availableTiers.some(tier => tier.rawThickness === 40) ? 40 : 52;
    const tiers = availableTiers.filter(tier => tier.rawThickness === rawThicknessUsed);
    const longest = tiers.length ? tiers[tiers.length - 1].length : 0;
    const longestUsable = Math.max(0, longest - totalEndTrimMm);
    const selected = tiers.find((tier) => tier.length - totalEndTrimMm >= requiredLength) ||
      tiers[tiers.length - 1] || { length: 0, price: c.woodPrice };
    const fingerJointCount = longestUsable > 0
      ? Math.max(0, Math.ceil(requiredLength / longestUsable) - 1)
      : 0;
    const fingerJointDepthBands = Math.ceil(s.depth / 150);
    const configuredRate = Number(c.fingerJointRate);
    const fingerJointRate = Number.isFinite(configuredRate) && configuredRate >= 0 ? configuredRate : 15;
    return {
      rawThicknessUsed,
      woodPriceUsed: selected.price,
      woodTierLength: selected.length,
      woodTierUsableLength: Math.max(0, selected.length - totalEndTrimMm),
      maxWoodLength: longest,
      maxUsableWoodLength: longestUsable,
      trimEachEndMm,
      requiredWoodLength: requiredLength,
      fingerJointCount,
      fingerJointDepthBands,
      fingerJointFee: fingerJointCount * fingerJointDepthBands * fingerJointRate,
    };
  }

  function calculate(c, s) {
    if (c.isFloating && s.depth > floatingDepthMax(c, s))
      throw Error("Tot 500 mm diep kan alleen bij maximaal 800 mm lengte, 40 mm dikte en één zijdrager links of rechts.");
    // Twee zijmuren: een nisplank heeft eigen montage- en prijscalculatie.
    // Nooit een zwevende wandplank offreren met twee zijdragers.
    if (c.isFloating && s.wallLeft && s.wallRight)
      throw Error("Bij twee zijmuren gebruik je de nisplankconfigurator.");
    const l = s.length / 1000,
      d = s.depth / 1000;
    const selectedWood = selectedWoodTier(c, s);
    const wood =
      (c.kind === "niche" ? nicheShape(s).woodLength / 1000 : l) *
      d *
      (selectedWood.rawThicknessUsed / 1000) *
      selectedWood.woodPriceUsed *
      (1 + c.loss / 100) *
      (1 + c.markup / 100);
    const machining =
      s.depth > c.glueThreshold ? c.glueRate * l * d : c.planeRate * l;
    const sanding = c.sandRate * l;
    const cnc = c.cncStart + c.cncRate * Math.max(0, l - 1);
    // Bovenfrees na de CNC: bij iedere nisplank, ongeacht de voorzijde.
    // Bij gewone houtplanken blijft de bestaande toeslag voor ronde randen gelden.
    const edges =
      c.isCabinetTop ? c.edgeRate * (2 * l + 2 * d) :
      c.kind === "niche" ? c.edgeRate * l :
      s.edges === "rounded" ? c.edgeRate * l : 0;
    const finishRate =
      c.kind === "niche"
        ? s.finish === "oil"
          ? c.finishOil
          : s.finish === "lacquer"
            ? c.finishLacquer
            : 0
        : 0;
    const finish = 2 * l * d * Number(finishRate || 0);
    const packing = c.packRate * l;
    // De speciale CNC-voorzijde is een meerprijs: rond of schuin, niet recht.
    const cncEdges =
      c.kind === "niche" && (s.edges === "rounded" || s.edges === "beveled")
        ? c.cncEdgeRate * l
        : 0;
    const supports = c.kind === "niche" ? nicheBrackets(c, s) : { brackets: 0 };
    const roundedCorners = c.isFloating && Array.isArray(s.roundedCorners)
      ? [...new Set(s.roundedCorners.filter((key) =>
        ["frontLeft", "frontRight"].includes(key) && !(key === "frontLeft" && s.wallLeft) && !(key === "frontRight" && s.wallRight)))]
      : [];
    const cornerRadius = roundedCorners.length ? Number(s.cornerRadius) : 40;
    if (c.isFloating && roundedCorners.length && (!Number.isInteger(cornerRadius) || cornerRadius < 10 || cornerRadius > 80))
      throw Error("Kies voor de hoekafronding een radius van 10 tot 80 mm.");
    const cornerRounding = roundedCorners.length * (c.isFloating ? Number(c.cornerPriceEx || 0) : 0);
    const sideEdges = c.isFloating && s.edges !== "straight"
      ? {left: Boolean(s.sideEdgeLeft) && !s.wallLeft, right: Boolean(s.sideEdgeRight) && !s.wallRight}
      : {left:false,right:false};
    // De voorrand is reeds verwerkt in cncEdges. Extra zijfreeswerk
    // wordt op basis van de werkelijke zijlengte (plankdiepte) berekend.
    const sideEdgeCost = (Number(sideEdges.left) + Number(sideEdges.right)) *
      (Number(c.cncEdgeRate || 0) * d);
    const spotRouting =
      c.kind === "niche" &&
      s.lighting === "yes" &&
      s.lightingType === "own-spots"
        ? Number(c.ownSpotRouting || 0)
        : 0;
    const stripRouting =
      c.kind === "niche" &&
      s.lighting === "yes" &&
      s.lightingType === "own-strip"
        ? Number(c.ownStripRouting || 0)
        : 0;
    const net =
      stripRouting +
      spotRouting +
      wood +
      selectedWood.fingerJointFee +
      machining +
      sanding +
      cnc +
      cncEdges +
      edges +
      finish +
      packing +
      c.start +
      c.shipping +
      supports.brackets +
      cornerRounding +
      sideEdgeCost;
    const { controlCents, spotUnitCents, spotCents } = lightingPrice(c, s);
    const cents =
      Math.round(net * (1 + c.vat / 100) + Number.EPSILON) * 100 +
      controlCents +
      spotCents;
    return {
      ...selectedWood,
      roundedCorners,
      sideEdges,
      sideEdgeCost,
      cornerRadius,
      cornerRounding,
      stripRouting,
      spotRouting,
      wood,
      machining,
      sanding,
      cnc,
      cncEdges,
      edges,
      finish,
      packing,
      controlCents,
      spotCents,
      spotUnitCents,
      ...supports,
      net,
      cents,
      total: (cents * s.quantity) / 100,
    };
  }

  function excludedRanges(text) {
    const toISO = (value) => {
      const match = value.trim().match(/^(\d{2})-(\d{2})-(\d{4})$/);
      const iso = match
        ? match[3] + "-" + match[2] + "-" + match[1]
        : value.trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return null;
      const date = new Date(iso + "T12:00:00Z");
      return Number.isFinite(date.getTime()) &&
        date.toISOString().slice(0, 10) === iso
        ? iso
        : null;
    };
    const ranges = [],
      errors = [];
    for (const line of String(text || "")
      .split(/[\n,;]+/)
      .map((s) => s.trim())
      .filter(Boolean)) {
      const parts = line.split(/\s+t\/m\s+|\s+tot\s+|\s*\.\.\s*/i);
      const start = toISO(parts[0]),
        end = toISO(parts[1] || parts[0]);
      if (parts.length > 2 || !start || !end || end < start) errors.push(line);
      else ranges.push([start, end]);
    }
    return { ranges, errors };
  }
  function deliveryDates(today, weeks, excluded = "", method = "ship") {
    const start = new Date(today + "T12:00:00Z");
    start.setUTCDate(start.getUTCDate() + Number(weeks) * 7);
    const dates = [],
      blocked = excludedRanges(excluded);
    if (blocked.errors.length) return dates;
    for (let i = 0; i < 84; i++) {
      const iso = start.toISOString().slice(0, 10);
      if (
        (method === "pickup" ? [4, 5] : [5, 6]).includes(start.getUTCDay()) &&
        !blocked.ranges.some(([from, to]) => iso >= from && iso <= to)
      )
        dates.push(iso);
      start.setUTCDate(start.getUTCDate() + 1);
    }
    return dates;
  }
  function amsterdamToday() {
    const p = new Intl.DateTimeFormat("en-CA", {
      timeZone: "Europe/Amsterdam",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(new Date());
    const get = (k) => p.find((x) => x.type === k).value;
    return get("year") + "-" + get("month") + "-" + get("day");
  }
  const dateLabel = (value) =>
    new Intl.DateTimeFormat("nl-NL", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone: "Europe/Amsterdam",
    }).format(new Date(value + "T12:00:00Z"));
  function lineProperties(s, date) {
    const afwerking =
      "Onbehandeld - " +
      (s.edges === "rounded" ? "afgeronde randen" : "rechte randen");
    const data = {
      lengte: String(s.length),
      breedte: String(s.depth),
      dikte: String(s.thickness),
      afwerking,
    };
    return {
      "Lengte (mm)": data.lengte,
      "Breedte (mm)": data.breedte,
      "Dikte (mm)": data.dikte,
      Afwerking: afwerking,
      Leverdatum: date,
      _data: JSON.stringify(data),
      _admin_summary:
        "Lengte (mm): " +
        data.lengte +
        "\nBreedte (mm): " +
        data.breedte +
        "\nDikte (mm): " +
        data.dikte +
        "\nAfwerking: " +
        afwerking,
    };
  }
  const api = {
    deepFloatingEligible,
    floatingDepthMax,
    nicheShape,
    nicheRearSupport,
    validateStrip,
    electricalLayout,
    validateSpotGeometry,
    nicheBrackets,
    calculate,
    deliveryDates,
    lineProperties,
    excludedRanges,
    amsterdamToday,
    dateLabel,
  };
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  else window.HomConfiguratorCore = Object.freeze(api);
})();






